<template>
  <div id="login">
    <v-container fluid>
      <div class="text-center incenter-logo">
        <a href="/">
          <v-img
            src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
            height="100"
            width="200"
            class="mx-auto"
          ></v-img>
        </a>
      </div>
      <v-card height="2" color="#FF7043"></v-card>

      <v-row align="center" justify="center">
        <v-flex class="pa-3" xs12 md4 lg4>
          <v-card raised>
            <v-container>
              <div class="text-center">
                <v-icon size="100">fas fa-money-bill-wave</v-icon>
              </div>
              <div class="text-center headline mb-10">Login Smart247.id</div>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  type="email"
                  v-model="email"
                  :rules="EmailRules"
                  label="E-mail"
                  outlined
                  required
                ></v-text-field>
                <v-text-field
                  type="password"
                  v-model="password"
                  :rules="PassRules"
                  label="Password"
                  outlined
                  required
                ></v-text-field>

                <v-btn
                  :disabled="!valid"
                  color="success"
                  outlined
                  block
                  class="mr-4"
                  @click="validate()"
                >Masuk</v-btn>
                <v-btn color="success" outlined block class="my-2" @click="goTo('daftar')">Daftar</v-btn>
                <v-btn @click="goTo('/')" class="my-5" block tile color="success">
                  <v-icon left>fas fa-home</v-icon>Kembali ke Home
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-flex>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      loading: false,
      valid: true,
      email: null,
      password: null,
      token: localStorage.getItem("token"),
      PassRules: [v => !!v || "Pass is required"],
      EmailRules: [v => !!v || "Email is required"]
    };
  },
  methods: {
    SignIn() {
      this.loading = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/Login", {
        method: "POST",
        body: JSON.stringify({ email: this.email, password: this.password }),
        headers: {
          "Content-type": "application/json"
        }
      })
        .then(response => response.json())
        .then(data => {
          this.loading = false;
          console.log(data);

          if (data.token != null) {
            this.$router.push("/");
            localStorage.setItem("token", data.token);
            localStorage.setItem("idkeranjang", data.keranjang);
            parseInt(localStorage.setItem("user_id", data.id));
            localStorage.setItem("alamat_id", data.alamat_id);
          } else {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: "Periksa Kembali Email dan Password Anda"
            });
          }
        });
    },
    SignUp() {
      this.$router.push("register");
    },
    back() {
      window.history.back();
    },
    validate() {
      this.$refs.form.validate();
      if (this.email != null && this.password != null) {
        this.SignIn();
      }
    },
    goTo(e) {
      this.$router.push(e);
    }
  }
};
</script>
<style scoped>
#login {
  background: #84ffff;
  height: 100%;
}
.incenter-logo {
  font-family: Tahoma, Geneva, sans-serif;
  font-size: 300%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #ff3d00;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: uppercase;
}
.incenter-logo-id {
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-size: 25px;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #546e7a;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: lowercase;
}
@media only screen and (max-width: 768px) {
  .web {
    display: none;
  }
}
</style>
